const clearLocalStorageUtil = async (): Promise<boolean> =>
  new Promise((resolve) => {
    localStorage.clear()
    resolve(true)
  })

export default clearLocalStorageUtil
